import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Typography,
  Grid,
  Box,
  Tooltip,
  styled,
  useTheme,
  Container,
} from '@mui/material'
import { toast } from 'react-toastify'

// Styled Components
// const Wrapper = styled(Box)(({ theme }) => ({
//   paddingTop: theme.spacing(4),
//   paddingBottom: theme.spacing(4),
//   paddingLeft: theme.spacing(2),
//   paddingRight: theme.spacing(2),
//   maxWidth: 'lg',
//   margin: '0 auto',
// }))

const TitleBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(6),
  position: 'relative',
}))

const Card = styled(Box)(({ theme }) => ({
  height: 260,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0',
  boxShadow: '0px 4px 16px rgba(0,0,0,0.06)',
  cursor: 'pointer',
  textAlign: 'center',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 24px rgba(0, 0, 0, 0.12)',
  },
}))

const FileName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
}))

const NoFilesText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(2),
}))

const DocumentList = ({
  data,
  title,
  basePath,
  iconPath,
  navigatePath = '',
  noFilesMessage = 'No files available',
}) => {
  const navigate = useNavigate()
  const theme = useTheme()

  const getFileIcon = (filename) => {
    const ext = filename?.split('.').pop().toLowerCase()
    switch (ext) {
      case 'pdf':
        return iconPath || basePath + 'DOCTYPE_ICONS/PDF_Icon.svg'
      case 'docx':
        return iconPath || basePath + 'DOCTYPE_ICONS/Doc_Icon.svg'
      default:
        return iconPath || basePath + 'DOCTYPE_ICONS/empty_icon.svg'
    }
  }

  const handleFileClick = (file) => {
    if (file.externalLink) {
      const fullUrl = /^https?:\/\//i.test(file.externalLink)
        ? file.externalLink
        : window.location.origin + file.externalLink
      window.open(fullUrl, '_blank')
      return
    }

    if (!file.pathurl) {
      toast.error('There is no file', {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }

    navigate(`${navigatePath}${file.pathurl}`)
  }

  return (
    <Container sx={{ maxWidth: 'lg', mx: 'auto', my: 8, px: { xs: 2, md: 4 } }}>
      {data.map((item, index) => (
        <Box key={index} sx={{ marginBottom: theme.spacing(6) }}>
          <TitleBox>
            <Typography
              variant="h4"
              className="mb-4"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: 'bold',
                mb: 2,
                position: 'relative',
                display: 'inline-block',
              }}
            >
              {title || item.title || 'Documents'}
              <Box
                sx={{
                  width: '50%',
                  height: 4,
                  backgroundColor: 'background.secondaryBackground',
                  position: 'absolute',
                  left: 0,
                }}
              />
            </Typography>
          </TitleBox>

          <Grid container spacing={4} justifyContent="center">
            {item.documents && item.documents.length > 0 ? (
              item.documents.map((file, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                  <Card onClick={() => handleFileClick(file)}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <img
                        src={getFileIcon(file.pathurl)}
                        alt="File Icon"
                        loading="lazy"
                        style={{
                          maxWidth: '100%',
                          maxHeight: 'auto',
                          objectFit: 'contain',
                          marginBottom: '1.2rem',
                        }}
                        onError={(e) => {
                          e.target.src =
                            basePath + 'DOCTYPE_ICONS/empty_icon.svg'
                        }}
                      />
                    </Box>
                    <Tooltip title={file.filename} placement="top" arrow>
                      <FileName variant="body2">{file.filename}</FileName>
                    </Tooltip>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <NoFilesText variant="body1">{noFilesMessage}</NoFilesText>
              </Grid>
            )}
          </Grid>
        </Box>
      ))}
    </Container>
  )
}

export default DocumentList
